import { iPermissionFields } from "./PermissionSection";
import { components } from "@apiSchema";

export enum ChainType {
    Restaurant = 1,
    Supermarket = 2,
    CStore = 3,
}

export type API__FPCHainDataExtended = components["schemas"]["FPChainData"] & {
    chainType: ChainType;
}

export interface iBrandData extends iPermissionFields {
    data: API__FPCHainDataExtended;
}

export class FPChainData implements API__FPCHainDataExtended {
    static defaultData: API__FPCHainDataExtended = {
        headerData: {
            circles: [],
            nps: 0,
            detractor: 0,
            passive: 0,
            promoter: 0,
        },
        situationAssessmentData: {
            strengths: [],
            weakness: [],
        },
        brandFunnelData: [],
        customerExperience: [],
        foodAndBeverageQuality: [],
        valueProposition: [],
        chainType: ChainType.Restaurant,
    };

    headerData = FPChainData.defaultData.headerData;
    situationAssessmentData = FPChainData.defaultData.situationAssessmentData;
    brandFunnelData = FPChainData.defaultData.brandFunnelData;
    customerExperience = FPChainData.defaultData.customerExperience;
    foodAndBeverageQuality = FPChainData.defaultData.foodAndBeverageQuality;
    valueProposition = FPChainData.defaultData.valueProposition;
    chainType = FPChainData.defaultData.chainType;
}
